export default "__VITE_ASSET__DDVM5Jge__"